import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
const LOGO_IMG = 'https://cdn.magicpatterns.com/uploads/sFfqXsBPv2Ybb2GnVtoWFu/heylloyd-image-1784219377898.webp';
type HeaderProps = {
  onCTA: () => void;
};
export function Header({
  onCTA
}: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-crema/95 shadow-sm backdrop-blur-md' : 'bg-crema/70 backdrop-blur-sm'}`} data-id="element-78" data-mp="31c8l6m7m5uqj">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6" data-id="element-79" data-mp="36cwbf5o0q7jp">
        <a href="#inicio" className="flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-rosa/40 rounded-lg" data-id="element-80" data-mp="3b8bmxqyjzrcy">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-crema" data-id="element-81" data-mp="2wmffsg9iew2k">
            <img src={LOGO_IMG} alt="Logo Cambio Hormonal" className="h-[4.5rem] w-[4.5rem] max-w-none object-cover" data-id="element-82" data-mp="2ro49gfifb3p3" />
          </span>
          <span className="leading-tight" data-id="element-83" data-mp="2hpoh697ntoe0">
            <span className="block font-serif text-base font-semibold text-tinta sm:text-lg" data-id="element-84" data-mp="3fbvj1bckx2mo">
              Cambio Hormonal
            </span>
            <span className="block text-[10px] uppercase tracking-[0.2em] text-dorado sm:text-xs" data-id="element-85" data-mp="3acra8ltkh6wv">
              El Método del 1%
            </span>
          </span>
        </a>
        <CTAButton onClick={onCTA} className="hidden sm:inline-flex" data-id="element-86" data-mp="30len27ipr4x6">
          Quiero mi app ahora
        </CTAButton>
        <CTAButton onClick={onCTA} className="sm:hidden !px-4 !py-2.5 !text-xs" data-id="element-87" data-mp="1y0kmewk5xvq">
          Quiero mi app
        </CTAButton>
      </div>
    </header>;
}